export { default } from './Svg';